
import {
  Input,
  Row,
  Col,
  Card,
  Typography,
  Space,
  Button,
  Form,
  Table,
  notification,
  Popconfirm,
} from "antd";
import { DeleteFilled, ExportOutlined, SyncOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
import "../Pages/CSS/DonnesBases.css";
import { useEffect, useState } from "react";

import { SpecialitesService } from "../Services/SpecialitesService";
const { Title } = Typography;
const Specialites = () => {
  const initialTableData = []; // Stocke les données initiales du tableau
  const initilNewSpecialite = {
    // Stocke les valeurs initiales du formulaire
    codespe: "",
    intitule: "",
    compte: "",
  };

  const [tableData, setTableData] = useState(initialTableData);
  const [filteredData, setFilteredData] = useState(initialTableData); // Utilise initialTableData pour initialiser filteredData
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(true);
  const [newSpecialites, setNewSpecialite] = useState(initilNewSpecialite);

  const specialitesService = new SpecialitesService();
  useEffect(() => {
    setLoading(true);
    specialitesService
      .getAllSpecialites() // Ajoutez les parenthèses pour appeler la fonction
      .then((data) => {
        setTableData(data);
        setLoading(false);
        
      })
      .catch((error) => {
        setLoading(false);
      });
      
    // eslint-disable-next-line
  }, []);
  const handleUpdate = async () => {
    try {
      if (selectedRowData) {
        await specialitesService.updateSpecialites(selectedRowData); // Utilise updatePrestation pour mettre à jour la prestation sélectionnée
        const updatedData = await specialitesService.getAllSpecialites();
        setTableData(updatedData);
        setSelectedRowData(null); // Réinitialise les données sélectionnées après la mise à jour
        notification.success({
          message: "Modification réussie",
          description: "La Specialité a été modifié avec succès.",
        });
      }
    } catch (error) {
      notification.error({
        message: "erreur",
        description: "Erreur lors de la modification de la Specialité",
      });
    }
  };
  useEffect(() => {
    setFilteredData(tableData); // Initialisation des données filtrées avec les données complètes au chargement
  }, [tableData]);

  const createPrestation = async () => {
    try {
      await specialitesService.addSpecialite(newSpecialites); // Utilisation de newSpecialites pour ajouter la nouvelle prestation
      // Après l'ajout avec succès, rafraîchissez les données
      const updatedData = await specialitesService.getAllSpecialites();
      setTableData(updatedData);
      setShowCreateForm(false); // Masquer le formulaire après l'ajout
      notification.success({
        message: "Ajout Specialité réussie",
        description: "La specialité a été ajouté avec succès.",
      });
    } catch (error) {
      notification.error({
        message: "erreur",
        description: "Erreur lors de l'ajout de la spécialité",
      });
    }
  };
  // Ensuite, dans mon fonction handleSave, appelez la fonction createPrestation :
  const handleSave = () => {
    createPrestation();
  };

  const handleDelete = async (compte) => {
    try {
      await specialitesService.deleteSpecialites(compte);
      const updatedData = await specialitesService.getAllSpecialites();
      setTableData(updatedData);
      setSelectedRowData(null); // Réinitialiser les données sélectionnées après la suppression
      notification.success({
        message: "Suppression réussie",
        description: "La specialité a été supprimé avec succès.",
      }); // Notification de suppression réussie
    } catch (error) {
      // Gérer les erreurs avec une notification d'erreur
      notification.error({
        message: "erreur",
        description: "Erreur lors de la suppression de la Spécialité",
      });
    }
  };

  const handleRowClick = (record) => {
    setSelectedRowData(record); // Mettre à jour les données de la ligne sélectionnée
    setShowCreateForm(false)
  };
  useEffect(() => {
    if (tableData.length > 0) {
      handleNew();
    }
  }, [tableData]);
  const handleNew = () => {
    setSelectedRowData(null);
    setShowCreateForm(true);

    const excludeCode = 99;
    const excludeCompte = "400099";

    let dataToConsider = [...tableData]; // Copie de tableData pour éviter de modifier l'original

    let lastCode = 0;
    let lastCompte = 0;

    // Trouver le dernier code et compte avant les exclusions
    for (let i = dataToConsider.length - 1; i >= 0; i--) {
      if (
        parseInt(dataToConsider[i].codespe) !== excludeCode &&
        dataToConsider[i].compte !== excludeCompte
      ) {
        lastCode = parseInt(dataToConsider[i].codespe);
        lastCompte = parseInt(dataToConsider[i].compte);
        break;
      }
    }

    let nextCode = lastCode + 1;
    while (nextCode === excludeCode) {
      nextCode++;
    }

    const nextCompte = (lastCompte + 1).toString().padStart(6, "0");

    setNewSpecialite({
      codespe: nextCode.toString().padStart(2, "0"),
      intitule: "",
      compte:
        nextCompte !== excludeCompte
          ? nextCompte
          : (parseInt(nextCompte) + 1).toString().padStart(6, "0"),
    });
};


  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Met à jour les données filtrées
  };

  const handleReset = async () => {
    try {
      const updatedData = await specialitesService.getAllSpecialites(); // Récupère les nouvelles données
      setTableData(updatedData); // Met à jour le tableau avec les nouvelles données
      setSelectedRowData(null); // Réinitialise les données sélectionnées
    } catch (error) {}
  };

  const handleExport = () => {
    const exportData = tableData.map((item) => ({
      Code: item.codespe,
      Libellé: item.intitule,
      Compte: item.compte,
      "Créer le": item.datecreation
        ? moment(item.datecreation).format("DD-MM-YYYY")
        : "", // Formate la date si elle existe
      "Créer par": item.create_by,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Spécialités");

    XLSX.writeFile(workbook, "export_Spécialités.xlsx");
  };

  const columns = [
    {
      title: "Code",
      dataIndex: "codespe",
      key: "codespe",
     // className: "small-cell",
      align:"center",
      ellipsis: true,
  //    width: "15%",
  sorter: (a, b) => {
    const valueA = a.codespe || "";
    const valueB = b.codespe || "";
    return valueA.localeCompare(valueB);
  },
      render: (text) => (
        <strong >{text}</strong>
      ),
    },
    {
      title: "Libellé",
      dataIndex: "intitule",
      key: "intitule",
   //   className: "small-cell",
      ellipsis: true,
     width: "40%",
     sorter: (a, b) => {
      const valueA = a.intitule || "";
      const valueB = b.intitule || "";
      return valueA.localeCompare(valueB);
    },
    },
    {
      title: "Compte",
      dataIndex: "compte",
      key: "compte",
      //className: "small-cell",
      align: "center",
      ellipsis: true,
     // width: "10%",
     sorter: (a, b) => {
      const valueA = a.compte || "";
      const valueB = b.compte || "";
      return valueA.localeCompare(valueB);
    },
    },
    {
      title: "Créer le",
      dataIndex: "datecreation",
      key: "datecreation",
  //    className: "small-cell",
      ellipsis: true,
   //   width: "10%",
      align: "center",
      
      render: (text) => text ? moment(text).format("DD/MM/YYYY") : "",
      sorter: (a, b) => {
        const valueA = new Date(a.datecreation).getTime();
        const valueB = new Date(b.datecreation).getTime();
        return valueA - valueB;
      },
        
      },
   
    {
      title: "Créer par",
      dataIndex: "create_by",
      key: "create_by",
  //    className: "small-cell",
      ellipsis: true,
    //  width: "10%",
    sorter: (a, b) => {
      const valueA = a.create_by || "";
      const valueB = b.create_by || "";
      return valueA.localeCompare(valueB);
    },
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      key: "action",
      className: "small-cell",
      align: "center",
      // className: 'custom-action-column'
      ellipsis: true,
     
      render: (text, record) => (
        <Popconfirm
          title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
          onConfirm={() => handleDelete(record.compte)}
          okText="Oui"
          cancelText="Non"
        >
          <Button
            danger
            style={{ border: "none", fontSize: "16px" }}
            icon={<DeleteFilled />}
          ></Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={18}>
          <Card>
            <Row gutter={[16, 16]}>
              <Col
                span={9}
                style={{
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                {/*  barre de recherche */}
                <Input
                  placeholder="Rechercher..."
                  bordered={false}
                  style={{ borderBottom: "1px solid #ccc" }}
                  onChange={(e) => handleSearch(e.target.value)}
                  onPressEnter={(e) => handleSearch(e.target.value)}
                />
              </Col>
              <Col
                span={15}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                {/* Vos boutons d'export et d'actualisation */}
                <Space>
                  <Button
                    className="buttonExport"
                    icon={<ExportOutlined />}
                    onClick={handleExport}
                  >
                    Export
                  </Button>
                  <Button className="buttonRefresh"  onClick={handleReset} icon={<SyncOutlined />}>
                    Actualiser
                  </Button>
                </Space>
              </Col>
            </Row>
          </Card>

          <Table
            className="custom-header1-table"
            bordered
            showSorterTooltip={false}
            // size='small'
               columns={columns}
            dataSource={filteredData}
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
            })}
            loading={loading}
          
          />
        </Col>

        <Col xs={24} xl={6}>
          {showCreateForm ? (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title level={4} style={{ margin: 0,marginLeft: "15px", color: "#ffffff" }}>
                  
                    Nouvelle Spécialité
                  </Title>
                </div>
              }
            >
              <Form layout="vertical">
                <Form.Item label="Code Spécialité">
                  <Input
                  readOnly
                    placeholder="Code Spécialité"
                    value={newSpecialites.codespe}
                    onChange={(e) =>
                      setNewSpecialite({
                        ...newSpecialites,
                        codespe: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="Libellé Spécialité">
                  <Input
                    placeholder="Libellé Spécialité"
                    value={newSpecialites.intitule}
                    onChange={(e) =>
                      setNewSpecialite({
                        ...newSpecialites,
                        intitule: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="Compte Spécialité">
                  <Input
                  readOnly
                    placeholder="Compte Spécialité"
                    value={newSpecialites.compte}
                    onChange={(e) =>
                      setNewSpecialite({
                        ...newSpecialites,
                        compte: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button
                      onClick={() => setShowCreateForm(false)}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Annuler
                    </Button>
                    <Button
                      type="primary"
                      onClick={handleSave}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Enregistrer
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          ) : (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title level={4} style={{ margin: 0, color: "#ffffff" }}>
                   
                    Modification Spécialité
                  </Title>
                </div>
              }
            >
              <Form layout="vertical">
                <Form.Item label="Code Spécialité">
                  <Input
                    placeholder="Code Spécialité"
                    value={selectedRowData ? selectedRowData.codespe : ""}
                  />
                </Form.Item>
                <Form.Item label="Libellé Spécialité">
                  <Input
                    placeholder="Libellé Spécialité"
                    value={selectedRowData ? selectedRowData.intitule : ""}
                    onChange={(e) =>
                      setSelectedRowData({
                        ...selectedRowData,
                        intitule: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="Compte Spécialité">
                  <Input
                    placeholder="Compte Spécialité"
                    value={selectedRowData ? selectedRowData.compte : ""}
                  />
                </Form.Item>
                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button
                      type="primary"
                      onClick={handleNew}
                      style={{
                        backgroundColor: "transparent",
                        color: "#010f1c",
                        borderColor: "#010f1c",
                      }}
                    >
                      Nouveau
                    </Button>
                    <Button
                      onClick={handleUpdate}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Modifier
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Specialites;
